import { NavLink, Route, Routes } from "react-router-dom";

import { cn } from "@/lib/utils";

import { CmPurchaseOrderListPage } from "./CmPurchaseOrderPage";
import { CmPoReceivingPage } from "./CmPoReceivingPage";
import { CmPoWorkOrderSkuDefaultsPage } from "./CmPoWorkOrderSkuDefaultsPage";
import { CmPoSupplierManufacturingLocationsPage } from "./CmPoSupplierManufacturingLocationsPage";

function secondaryTabCls({ isActive }: { isActive: boolean }): string {
  return cn(
    "inline-flex shrink-0 items-center rounded-t-md border border-b-0 px-3 py-2 text-sm font-medium transition-colors",
    isActive
      ? "-mb-px border-slate-200 bg-white text-slate-900"
      : "border-transparent text-slate-600 hover:border-slate-200 hover:bg-slate-50",
  );
}

/**
 * Nested routes under Manufacturing → CM PO: purchase order list, work-order SKU presets for Create CM PO,
 * and configurable supplier → manufacturing location bindings for sub work orders.
 */
export function CmPurchaseOrderSection() {
  return (
    <div className="space-y-4">
      <nav className="-mb-px flex flex-wrap gap-1 border-b border-slate-200" aria-label="CM purchase orders">
        <NavLink to="." end className={secondaryTabCls}>
          Purchase orders
        </NavLink>
        <NavLink to="receiving" className={secondaryTabCls}>
          CM PO receiving
        </NavLink>
        <NavLink to="defaults" className={secondaryTabCls}>
          Work order defaults
        </NavLink>
        <NavLink to="supplier-sites" className={secondaryTabCls}>
          CM supplier sites
        </NavLink>
      </nav>
      <Routes>
        <Route index element={<CmPurchaseOrderListPage />} />
        <Route path="receiving" element={<CmPoReceivingPage />} />
        <Route path="defaults" element={<CmPoWorkOrderSkuDefaultsPage />} />
        <Route path="supplier-sites" element={<CmPoSupplierManufacturingLocationsPage />} />
      </Routes>
    </div>
  );
}
